import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import { goBack, pushPage, redirect, showErrorToast } from '@shared/actions';
import {
  getCurrencySymbol,
  getIsUserLogged,
  getIsDesktopLayout,
  getCountryShortName,
} from '@shared/selectors';

import { getShopInfo, getShopMaxProductQuantity } from '@conversion/selectors';

import getCartDiscounts from '@core/reducers/cart/selectors/getCartDiscounts';

import getCartSubtotal from '@core/reducers/cart/selectors/getCartSubtotal';

import getCartItems from '@core/reducers/cart/selectors/getCartItems';
import getCartItemsRequireValidate from '@core/reducers/cart/selectors/getCartItemsRequireValidate';
import getAreOnlyDonationsItemsInCart from '@core/reducers/cart/selectors/getAreOnlyDonationsItemsInCart';
import deleteLines from '@core/reducers/cart/actions/deleteLines';
import fetchProductsRequireValidate from '@core/reducers/cart/actions/fetchProductsRequireValidate';
import trackAddMoreFoodClicked from '@conversion/tracking/actions/trackAddMoreFoodClicked';
import trackCheckoutClicked from '@conversion/tracking/actions/trackCheckoutClicked';
import trackModalOpened from '@tracking/actions/trackModalOpened';
import trackModalClosed from '@tracking/actions/trackModalClosed';
import trackCartDeleted from '@conversion/tracking/actions/trackCartDeleted';
import getNeedsToAdd from '@cart/selectors/getNeedsToAdd';
import {
  getShopBusinessType,
  getRedirectToShopDetails,
} from '@shopDetails/selectors';
import updateCartNotes from '@core/reducers/cart/actions/updateCartNotes';
import registerCartReducer from '@cart/register';
import getIsUpdatingLines from '@core/reducers/cart/selectors/getIsUpdatingLines';
import getCartTotalProductsQuantity from '@core/reducers/cart/selectors/getCartTotalProductsQuantity';
import trackToastShown from '@shopDetails/tracking/actions/trackToastShown';

import getShowPhoneValidationModalForCart from '@myAccountVerification/selectors/getShowPhoneValidationModalForCart';
import getCartShippingAmount from '@core/reducers/cart/selectors/getCartShippingAmount';
import getCartPlusInfo from '@core/reducers/cart/selectors/getCartPlusInfo';
import getCartId from '@core/reducers/cart/selectors/getCartId';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import getSearchedLocation from '@location/selectors/getSearchedLocation';
import selectUserTotalOrders from '@core/reducers/user/selectors/selectUserTotalOrders';
import Cart from './Cart';

registerCartReducer();

const mapStateToProps = createStructuredSelector({
  shop: getShopInfo,
  cartSubtotal: getCartSubtotal,
  cartDiscounts: getCartDiscounts,
  cartItems: getCartItems,
  cartItemsRequireValidate: getCartItemsRequireValidate,
  needsToAdd: getNeedsToAdd,
  currencySymbol: getCurrencySymbol,
  redirectToShopDetails: getRedirectToShopDetails,
  isUserLogged: getIsUserLogged,
  countryShortName: getCountryShortName,
  businessType: getShopBusinessType,
  areOnlyDonationsItemsInCart: getAreOnlyDonationsItemsInCart,
  isDesktopLayout: getIsDesktopLayout,
  showPhoneVerificationModal: getShowPhoneValidationModalForCart,
  isUpdatingLines: getIsUpdatingLines,
  cartTotalProductsQuantity: getCartTotalProductsQuantity,
  shopMaxProducts: getShopMaxProductQuantity,
  shippingAmount: getCartShippingAmount,
  plusSettings: getCartPlusInfo,
  shopId: getShopId,
  cartId: getCartId,
  searchedLocation: getSearchedLocation,
  userTotalOrders: selectUserTotalOrders,
});

const mapDispatchToProps = {
  deleteLines,
  trackAddMoreFoodClicked,
  trackCheckoutClicked,
  trackCartDeleted,
  trackModalOpened,
  trackModalClosed,
  goBack,
  pushPage,
  redirect,
  updateCartNotes,
  fetchProductsRequireValidate,
  showErrorToast,
  trackToastShown,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(Cart);
